import { SimplePool } from "nostr-tools";
export const pool = new SimplePool();
